var map = {
	"./Candy.webp": "ef29",
	"./Flamingo.webp": "e09d",
	"./GasbotSideTopRobot.webp": "74cd",
	"./Gm.webp": "6c1274",
	"./Nep.webp": "c436",
	"./Nudes.webp": "f355",
	"./SwapTokenError.svg": "d8de",
	"./SwapTokenLoading.svg": "7f91",
	"./SwapTokenSuccess.svg": "7479",
	"./addresses.svg": "6830",
	"./allTimeTransactions.svg": "5afe",
	"./arrow-decrease.webp": "edce",
	"./arrow-down.svg": "2e6e",
	"./arrow-increase.webp": "7c96",
	"./arrow-left-purple.png": "cc38",
	"./arrow-redirect.svg": "f2bc",
	"./arrow-right-purple.png": "2670",
	"./arrow-up-order.svg": "187e",
	"./arrow-up-white.png": "474e",
	"./arrow-up.png": "e60e",
	"./asterisk.svg": "0478",
	"./bNeo.webp": "6d1c",
	"./banner-gleede-mobile.svg": "0570",
	"./banner-gleede.svg": "b405",
	"./bg-gleeder-mobile.png": "5b23",
	"./bg-gleeder.png": "b51e",
	"./bneo-icon.svg": "900c",
	"./bneo.png": "d827",
	"./boomerang.svg": "2ef9",
	"./burger.png": "9763",
	"./burger.svg": "6ab0",
	"./calculator.svg": "b643",
	"./caret-down.svg": "e40a",
	"./caret-left.webp": "8b28",
	"./caret-right-green-2.svg": "e84a",
	"./caret-right-green.svg": "68a7",
	"./caret-right-primary.svg": "d647",
	"./caret-right.svg": "ed41",
	"./caret-right.webp": "cbf1",
	"./caret-rotate.svg": "1c99",
	"./caret-up.svg": "53fe",
	"./carret-down.svg": "9c4a",
	"./carrot-swap.svg": "524e",
	"./check-circle.svg": "a7b6",
	"./check-icon.svg": "3a0d",
	"./check.svg": "6aa8",
	"./christmas/background.png": "11f6",
	"./christmas/bells.png": "aa02",
	"./christmas/fairy_light_1.png": "7d36",
	"./christmas/fairy_light_2.png": "8738",
	"./christmas/fairy_light_gas_calculator_1.png": "1038",
	"./christmas/garland_1.png": "d688",
	"./christmas/garland_2.png": "2d4b",
	"./christmas/gasbot_eyes_opened.png": "a1f4",
	"./christmas/gasbot_left.png": "6451",
	"./christmas/gasbot_side_right.png": "093b",
	"./christmas/gasbot_smile.png": "5d9f",
	"./christmas/ndapp.png": "b746",
	"./christmas/noel_hat.png": "9947",
	"./claim-button-disabled-background.png": "41c2",
	"./claim-modal-background.png": "382d",
	"./clock_icon.svg": "95ca",
	"./close-green.svg": "96a4",
	"./close.svg": "1d1b",
	"./coin-icon.svg": "3bac",
	"./coins-icon.svg": "e6e9",
	"./connected-icon-purple.png": "2ac1",
	"./connected-icon.svg": "5305",
	"./connection-icon.svg": "0235",
	"./copy-icon.svg": "bad7",
	"./copy.svg": "87d1",
	"./copy.webp": "1ee8",
	"./create-orbit-background.png": "4ac8",
	"./deeplink-icon.svg": "52b3",
	"./desktop-icon.svg": "5c7c",
	"./disconnected-icon.svg": "8162",
	"./discord-blue.png": "9f36",
	"./discord-white.png": "9181",
	"./divider-purple.png": "cd54",
	"./dora-icon.svg": "efbf",
	"./dora-logo.svg": "3eec",
	"./dora.svg": "b20f",
	"./down-arrow-circle.svg": "79d2",
	"./down-chevron.svg": "65c8",
	"./exit-icon.svg": "693d",
	"./expand-icon.svg": "b8f5",
	"./expand-more.svg": "c2cd",
	"./eye.svg": "9be9",
	"./facebook.webp": "aa5f",
	"./file-document.webp": "efdb",
	"./flamingo-icon.svg": "7f17",
	"./for-the-win-logo.svg": "bbb1",
	"./gas-calculator-page.svg": "4216",
	"./gas-icon-black.svg": "1e7d",
	"./gas-icon.png": "a23c",
	"./gas.svg": "1b59",
	"./gas_rewards_icon.svg": "42a7",
	"./gasbot-discord-logos.webp": "3b44",
	"./gasbot-eyes-opened.png": "65ce",
	"./gasbot-icon.svg": "1b4e",
	"./gasbot-side-left.webp": "5fbe",
	"./gasbot-side-right.webp": "29af",
	"./gasbot-side-top.webp": "ecb3",
	"./gasbot-smile.webp": "1d11",
	"./ghostmarket-icon.svg": "876d",
	"./github.svg": "6bff",
	"./glasses-icon.svg": "9be5",
	"./gleeder-desktop-banner.png": "0575",
	"./gleeder-icon.svg": "233a",
	"./gleeder-logo.svg": "ffc4",
	"./gleeder-mobile-banner.png": "63ab",
	"./google-icon.png": "b4a9",
	"./google-plus.webp": "0866",
	"./hardware-icon.svg": "3603",
	"./icon-branch.svg": "7291",
	"./icon-code-lines.svg": "9f71",
	"./icon-commit.svg": "a40f",
	"./icon-contributors.svg": "9b04",
	"./icon-language.svg": "f330",
	"./icon-less.svg": "7cbd",
	"./icon-more.svg": "96e0",
	"./icon-organization-neo.webp": "5b55",
	"./icon-star.svg": "74f0",
	"./icon-swap.svg": "8ad1",
	"./info-gray-icon.svg": "767d",
	"./info-icon-without-background.svg": "fae6",
	"./info-icon.svg": "b3c5",
	"./information.svg": "425c",
	"./ketchup-icon.png": "75a6",
	"./laptop-icon.svg": "b959",
	"./left-chevron-green.svg": "38f1",
	"./linkedin.webp": "e5a7",
	"./lock.svg": "ad78",
	"./logo-ndapp.svg": "9440",
	"./logo-ndapp.webp": "16ea",
	"./logo.webp": "8e99",
	"./logout-icon.svg": "6d65",
	"./magnet-icon.svg": "af4d",
	"./menu-material.svg": "2e7a",
	"./money-bag-purple.png": "60cd",
	"./money-bag.png": "d95a",
	"./my-nfts-icon.svg": "c479",
	"./my-tokens-icon.svg": "0463",
	"./n3statistics.svg": "8768",
	"./neo-bg-image.webp": "1991",
	"./neo-bg-white.svg": "5ad8",
	"./neo-burger-simple.svg": "7abe",
	"./neo-burger-white-icon.svg": "fd9d",
	"./neo-burger.svg": "4260",
	"./neo-icon-green.svg": "aaea",
	"./neo-icon-white.svg": "db82",
	"./neo-icon.svg": "2252",
	"./neo.svg": "c2f9",
	"./neo.webp": "e7d3",
	"./neoburger-mobile.png": "b9aa",
	"./neoline.png": "fd87d",
	"./neonwallet.png": "d117",
	"./neox-icon.svg": "661e",
	"./neox.svg": "4823",
	"./neoxstatistics.svg": "a21d",
	"./network-history-icon.svg": "b82a",
	"./networkContracts.svg": "1d20",
	"./news.svg": "a1e0",
	"./not-available.png": "b7bb",
	"./notebook-burger.svg": "67c73",
	"./one-gate.png": "43e5",
	"./orbit-banner-mobile-m.png": "77bd",
	"./orbit-banner-mobile-s.png": "ee3a",
	"./orbit-banner.png": "1275",
	"./orbit-card-pool-claims.png": "706c",
	"./orbit-card-pool-participations.png": "19fc",
	"./orbit-card-total-rewards.png": "5886e",
	"./orbit-card-total-token-rewards-mobile.png": "2d3b",
	"./orbit-card-total-token-rewards.png": "c44a",
	"./orbit-card-total-txs.png": "2476",
	"./orbit-card-total-usd-rewards.png": "1b08",
	"./orbit-claim-modal-background.png": "1758",
	"./orbit-homepage-background-mobile-l.png": "f004",
	"./orbit-homepage-background-mobile-s.png": "091a",
	"./orbit-homepage-background-mobile.png": "4555",
	"./orbit-homepage-background.png": "fa6a",
	"./orbit-icon-dapp.png": "c077",
	"./orbit-icon.svg": "1467",
	"./orbit-learn-more-modal-background.png": "6140",
	"./orbit-logo.png": "547a",
	"./orbit-planet-claim.png": "a2f8",
	"./orbit-planet.png": "53c7",
	"./orbit-planets.png": "d870",
	"./orbit-realistic-icon.png": "0f70",
	"./orbit-white.png": "13c1",
	"./padlock-opened.png": "7773",
	"./pencil-icon.svg": "29095",
	"./percentage.svg": "9633",
	"./phone-icon.svg": "ddde",
	"./pinterest.webp": "413b",
	"./purple-money-bag.png": "2e98",
	"./qrcode-icon.svg": "c101",
	"./question-mark.svg": "3e99",
	"./quirkysoulcollege-icon.svg": "ecfd",
	"./recently-added.svg": "80d7",
	"./refresh.svg": "8d7e",
	"./right-arrow-long-primary.svg": "f777",
	"./search.svg": "6f6b",
	"./share-icon.svg": "986f",
	"./square-selected.svg": "cce5",
	"./swap-icon.svg": "49ed",
	"./swap.svg": "368e",
	"./terms-and-conditions-gasbot-image.webp": "198b",
	"./timer-icon.svg": "94af",
	"./tokens.svg": "3fdb",
	"./tokens/bneo.png": "8c9d",
	"./tokens/cake.png": "1eac",
	"./tokens/flm.png": "5186",
	"./tokens/frank.png": "b37c",
	"./tokens/fusd.png": "54db",
	"./tokens/gas.png": "9748",
	"./tokens/ndmeme.svg": "8be7",
	"./tokens/ndmeme.webp": "7b39",
	"./tokens/nudes.png": "9aa7",
	"./top-dapps.svg": "3579",
	"./top-nfts.svg": "278d",
	"./transactions.svg": "8291",
	"./trophy-purple.png": "02ff",
	"./trophy.png": "7116",
	"./ttm.webp": "df3d",
	"./twitter-x.webp": "3288",
	"./twitter.webp": "8815",
	"./wallet-icon-black.svg": "3e7c",
	"./wallet-icon-green.svg": "a943",
	"./wallet-icon.svg": "8c93",
	"./walletconnect-icon.svg": "1b0e",
	"./walletconnect.svg": "49f3",
	"./wallets/neoline.png": "bef1",
	"./wallets/neon.png": "aaac",
	"./wallets/onegate.jpg": "7ae4",
	"./warning-icon.svg": "97c4",
	"./website-icon.svg": "3411",
	"./world-of-elements-icon.webp": "bf4d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bb6e";